module.exports = __webpack_public_path__ + "static/pianopiano-logo-bd5dab8566a78d5b3982d7157867ca46.jpeg";